var map = {
	"./emag1.jpg": 8956,
	"./emag2.jpg": 475,
	"./emag3.jpg": 4638,
	"./emag4.jpg": 8053,
	"./emag5.jpg": 6872,
	"./emag6.jpg": 9719,
	"./emag7.jpg": 7562,
	"./emag8.jpg": 9617,
	"./mailbox.jpg": 6655,
	"./microphone.jpg": 8959,
	"./newsletterPressOffice.jpg": 6625
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7367;